import React from 'react';
import ThreeCol from '../containers/threeCol';

const Slide = (props) => {
  const styles = {
    border:"0px solid #444",
    display:"block",
    boxSizing:"border-box",
  }

  let border="0px solid #444";
  if(props.hasBorder==="true" && window.innerWidth>899){ 
    border=props.i===0 ||props.i%2===1 ?("1px solid #444"):"0px solid #444";
  }
  let visible={
    position:"absolute",
    left:"-10000px",
    top:"auto",
    width:"1px",
    height:"1px",
    overflow:"hidden",
    borderRight:"0px solid #444",
    margin:0,
  };
  if (props.i<props.show) {
    visible={
      display:"block",
      borderRight:border, 
      height:"245px",
      float:"left",
      margin:0,
    };
  }
  
  // Full width slider drops defaults
  if (props.isFull === true) {
    return(
      <div className="fullRow" tabIndex="-1" style={props.fullWidth.containerStyles}>
        <li tabIndex="-1" 
          style={{
            ...visible,
            ...props.fullWidth.liStyles,
          }} 
          className={"slide"+props.i}>
          {props.children}
        </li>
      </div>
    );
  } else {
    return (
      <ThreeCol width="32%" styles={{
        fontFamily: "Oswald",
        //padding:"15px",
        textTransform:"uppercase",
        lineHeight:" 19px",
        float:"left",
        border:"0px dashed #cc00cc",
        display:"inline-block",
        marginTop:"24px",
      }}>
        <li tabIndex="-1" 
          style={{
            margin:0,
            width:"100%",
            ...props.styles,
            ...styles,
            ...visible,
            padding:props.padding,
          }} 
          className={"slide"+props.i}>
          {props.children}
        </li>
      </ThreeCol>
    );
  }
}

Slide.defaultProps = {
  children: "No Data For Slide",
  fullWidth: {
    liStyles: { height: "auto" }
  }
};

export default Slide;
